export default function PopupConfirmation({ show, closeBetSlipParent }) {
  if (!show) return null;

  const agree = () => {
    closeBetSlipParent(true);
  };

  const disAgree = () => {
    closeBetSlipParent(false);
  };

  return (
    <>
      <style>
        {`
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 810px;
                        max-height: 90vh;
                        margin-top: 0px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }

                    .blink_me {
                        animation: blinker 1s linear infinite;
                    }
                    .casinoimp {
                        animation: casinoimpblinker 1s linear infinite;
                    }
                    .text-danger {
                        color: #dc3545 !important;
                    }
                    .h5, h5 {
                        font-size: 1.25rem;
                    }
                `}
      </style>
      <div
        class="modal fade show"
        id="modalMarketRules"
        tabindex="-1"
        style={{ display: "block" }}
      >
        <div className=" modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                All Casino Rules
              </h5>
              {/*<button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={agree}
              >
                <span aria-hidden="true">×</span>
                </button>*/}
            </div>
            <div id="market-rules-text" class="modal-body">
              <div id="casino-tos-text">
                <p></p>
                <center>
                  <h3 class="text-danger blink_me">Very Very Important !</h3>
                </center>
                <p></p>

                <p></p>
                <center>
                  <h5 class="text-danger casinoimp">
                    All casino profitLoss will be 1 to 10 Ratio from now.
                  </h5>
                </center>
                <p></p>

                <p></p>
                <center>
                  All casinos pay 10 times your win. For example, if you win
                  1000 in any casino, you will get 10,000 credits on our
                  exchange. The same applies to Loss. For example, if you Loss
                  1000 in any casino, you will Loss 10,000 on our exchange.
                  Thankyou
                </center>
                <p></p>

                <p></p>
                <center>
                  <h5 class="text-danger casinoimp">
                    Tamam casino may jeet Har 1 ka 10 gunah ho ge.
                  </h5>
                </center>
                <p></p>

                <p> </p>
                <center>
                  Her Casino may Har Jeet 5 Gunah ho gee . Agr Casino mey 1000
                  Jeeto gey to aap k Exchange account mey 10,000 aye gey OR agr
                  1000 Lose kray gey to aap k exchange account sey 10,000 minus
                  ho gey.
                </center>
                <p></p>
              </div>
            </div>

            <div class="modal-footer">
              <div class="form-check">
                <label class="form-check-label" for="exampleCheck1">
                  I Agree
                </label>
              </div>

              <button
                type="button"
                class="btn btn-primary ml-3"
                onClick={agree}
              >
                <strong>Confirm</strong>
              </button>

              <button
                type="button"
                class="btn btn-danger ml-3"
                data-bs-dismiss="modal"
                onClick={disAgree}
              >
                <strong>Don't Agree</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
